import { required } from 'vuelidate/lib/validators'

const formData = {
  id: {
    iterable: false,
    value: null
  },

  type: {
    iterable: false,
    type: 'radio',
    name: 'type',
    required: true,
    radios: [
      {
        label: 'Receita',
        name: 'RECEITA',
        value: 'RECEITA'
      },
      {
        label: 'Despesa',
        name: 'DESPESA',
        value: 'DESPESA'
      }
    ],
    value: null
  },

  date: {
    iterable: true,
    icon: 'calendar',
    type: 'text',
    name: 'date',
    placeholder: 'Data do lançamento',
    mask: '##/##/####',
    class: 'financial-statement__input',
    required: true,
    value: null
  },

  description: {
    iterable: true,
    icon: 'note',
    type: 'text',
    name: 'description',
    placeholder: 'Descrição',
    class: 'financial-statement__input',
    maxlength: 50,
    required: true,
    value: null
  },

  category: {
    iterable: true,
    icon: 'category',
    type: 'select',
    name: 'category',
    placeholder: 'Selecione a categoria',
    class: 'financial-statement__select',
    required: true,
    value: null,
    options: []
  },

  value: {
    iterable: true,
    icon: 'dollar',
    type: 'currency',
    name: 'value',
    placeholder: 'Valor',
    mask: '####',
    class: 'financial-statement__input',
    value: {
      converted: null,
      raw: 0
    }
  },

  paymentMethod: {
    iterable: true,
    icon: 'payment',
    type: 'select',
    name: 'paymentMethod',
    placeholder: 'Pagamento',
    class: 'financial-statement__select',
    options: [
      {
        id: 1,
        name: 'Cartão de débito',
        value: 'CARTÃO DE DÉBITO'
      },
      {
        id: 2,
        name: 'Cartão de crédito',
        value: 'CARTÃO DE CRÉDITO'
      },
      {
        id: 3,
        name: 'Dinheiro',
        value: 'DINHEIRO'
      },
      {
        id: 4,
        name: 'Cheque',
        value: 'CHEQUE'
      },
      {
        id: 5,
        name: 'Boleto',
        value: 'BOLETO'
      },
      {
        id: 6,
        name: 'Transferência Bancária',
        value: 'TRANSFERÊNCIA BANCÁRIA'
      }
    ],
    value: null
  },

  paymentStatus: {
    iterable: false,
    value: 0
  }
}

const validations = {
  type: {
    value: {
      required
    }
  },

  date: {
    value: {
      required,
      isValidDate (value) {
        if (value) {
          const date = this.$moment(value, 'DD/MM/YYYY', true)
          return date.isValid()
        }

        return false
      }
    }
  },

  description: {
    value: {
      required
    }
  },

  category: {
    value: {
      required
    }
  },

  value: {
    value: {
      required,
      isNotNull (value) {
        return ('converted' in value) ? (!!value.converted) : false
      }
    }
  },

  paymentMethod: {
    value: {
      required
    }
  },

  paymentStatus: {
    value: {
      required
    }
  }
}

export { formData, validations }
